import styled from '@emotion/styled';
import ThumbnailWrapper from '../BannerWrapper';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import mediaQuery from '@/lib/styling/mediaQuery';

const ErrorStateWrapper = styled(ThumbnailWrapper)(
  ({ theme }) => ({
    [mediaQuery(800)]: {
      height: 'auto',
      minHeight: 200,
    },
    '> div': {
      display: 'flex',
      maxWidth: 500,
      '> .MuiSvgIcon-root': {
        marginRight: 12,
      },
    },
    p: {
      marginTop: 4,
      marginBottom: 12,
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
    '.MuiButton-root': {
      backgroundColor: theme.palette.action.selected,
      ':hover': {
        backgroundColor: theme.palette.action.disabled,
      },
    },
  }),
  addHighContrastStyles(({ theme }) => {
    if (theme.isDark) {
      return {
        '.MuiButton-root': {
          backgroundColor: 'black',
          ':hover, :focus': {
            backgroundColor: 'transparent',
          },
        },
      };
    }
  }),
);

export default ErrorStateWrapper;
